import { Svg } from '@repo/ui';

import ErrorBaseView, { ErrorBaseViewController } from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';

interface Props {
  onPrimaryButtonClick: () => void;
}

const HometaxTimeoutError = ({ onPrimaryButtonClick }: Props) => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <Svg src="icg_megaphone_md.svg" width={80} height={80} />,
    title: '현재 홈택스 이용자가 많아\n일시적으로 조회가 어려워요',
    description: '이용에 불편을 드려 죄송합니다.\n다시 시도해주세요.',
    primaryButtonText: '다시 시도',
    onPrimaryButtonClick: onPrimaryButtonClick,
    primaryButtonVariant: 'filled-primary'
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export default HometaxTimeoutError;
